/** Site geneli modern yazı tipi seçenekleri (Google Fonts). */
export interface StorefrontFontPreset {
  key: string;
  /** CSS font-family değeri */
  value: string;
  /** Google Fonts family parametresi; yoksa sistem fontu */
  googleFamily?: string;
  /** Serif / sans etiket ipucu */
  category: 'sans' | 'serif';
}

export const DEFAULT_STOREFRONT_FONT = 'Inter, sans-serif';

export const STOREFRONT_FONT_PRESETS: StorefrontFontPreset[] = [
  {
    key: 'inter',
    value: 'Inter, sans-serif',
    googleFamily: 'Inter:wght@400;500;600;700',
    category: 'sans'
  },
  {
    key: 'poppins',
    value: 'Poppins, sans-serif',
    googleFamily: 'Poppins:wght@400;500;600;700',
    category: 'sans'
  },
  {
    key: 'dmSans',
    value: '"DM Sans", sans-serif',
    googleFamily: 'DM+Sans:wght@400;500;600;700',
    category: 'sans'
  },
  {
    key: 'plusJakarta',
    value: '"Plus Jakarta Sans", sans-serif',
    googleFamily: 'Plus+Jakarta+Sans:wght@400;500;600;700',
    category: 'sans'
  },
  {
    key: 'manrope',
    value: 'Manrope, sans-serif',
    googleFamily: 'Manrope:wght@400;500;600;700',
    category: 'sans'
  },
  {
    key: 'outfit',
    value: 'Outfit, sans-serif',
    googleFamily: 'Outfit:wght@400;500;600;700',
    category: 'sans'
  },
  {
    key: 'spaceGrotesk',
    value: '"Space Grotesk", sans-serif',
    googleFamily: 'Space+Grotesk:wght@400;500;600;700',
    category: 'sans'
  },
  {
    key: 'sora',
    value: 'Sora, sans-serif',
    googleFamily: 'Sora:wght@400;500;600;700',
    category: 'sans'
  },
  {
    key: 'nunito',
    value: 'Nunito, sans-serif',
    googleFamily: 'Nunito:wght@400;500;600;700',
    category: 'sans'
  },
  {
    key: 'rubik',
    value: 'Rubik, sans-serif',
    googleFamily: 'Rubik:wght@400;500;600;700',
    category: 'sans'
  },
  {
    key: 'montserrat',
    value: 'Montserrat, sans-serif',
    googleFamily: 'Montserrat:wght@400;500;600;700',
    category: 'sans'
  },
  {
    key: 'playfair',
    value: '"Playfair Display", serif',
    googleFamily: 'Playfair+Display:wght@400;500;600;700',
    category: 'serif'
  },
  {
    key: 'lora',
    value: 'Lora, serif',
    googleFamily: 'Lora:wght@400;500;600;700',
    category: 'serif'
  },
  {
    key: 'system',
    value: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    category: 'sans'
  }
];

const GOOGLE_FONTS_LINK_ID = 'gts-storefront-font-preview';

/** Admin önizleme için tüm Google Fontları yükler. */
export const ensureStorefrontFontPreviewLoaded = (): void => {
  if (typeof document === 'undefined') return;
  if (document.getElementById(GOOGLE_FONTS_LINK_ID)) return;

  const families = STOREFRONT_FONT_PRESETS.map((p) => p.googleFamily).filter(Boolean) as string[];
  if (families.length === 0) return;

  const href = `https://fonts.googleapis.com/css2?${families
    .map((f) => `family=${f}`)
    .join('&')}&display=swap`;

  const link = document.createElement('link');
  link.id = GOOGLE_FONTS_LINK_ID;
  link.rel = 'stylesheet';
  link.href = href;
  document.head.appendChild(link);
};

export const normalizeStorefrontFont = (value: unknown): string => {
  const raw = String(value || '').trim();
  if (!raw) return DEFAULT_STOREFRONT_FONT;
  const found = STOREFRONT_FONT_PRESETS.find(
    (p) => p.value.toLowerCase() === raw.toLowerCase() || p.key === raw
  );
  return found?.value || raw;
};

export const findStorefrontFontPreset = (value: unknown): StorefrontFontPreset | undefined => {
  const normalized = normalizeStorefrontFont(value);
  return STOREFRONT_FONT_PRESETS.find((p) => p.value.toLowerCase() === normalized.toLowerCase());
};
